module.exports = __webpack_public_path__ + "static/img/background.6bedfd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/motion/background.jpg
// module id = oQJi
// module chunks = 2